import { Money } from './Money';

export function coerceMoneyValue(value: unknown): Money | null {
  if (!value || typeof value !== 'object') {
    return null;
  }

  const money = value as Record<string, unknown>;
  const rawAmount = money.amount;
  let amount: number;

  if (typeof rawAmount === 'number') {
    amount = rawAmount;
  } else if (typeof rawAmount === 'string' && rawAmount !== '') {
    amount = Number(rawAmount);
  } else {
    return null;
  }

  if (!Number.isFinite(amount)) {
    return null;
  }

  return {
    amount,
    currencyCode: typeof money.currencyCode === 'string' ? money.currencyCode : 'RUB',
  };
}
